// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2eUp5","errorLogs":"styles_errorLogs__28Gkf"};